
window.SD_SHOW_MORE_CARDS = function () {
	const LOAD_AMOUNT = window.SD_LOAD_MORE || 6;

	const sectionCardsThreeCol = document.querySelector('.section-cards-three-col');
	const cardsWrapper = document.querySelector('.grid-three-col');
	const showMoreWrapper = document.querySelector('#view-more-cards');
	const cards = [...cardsWrapper.children];

	if (sectionCardsThreeCol && cardsWrapper && showMoreWrapper) {
		// get hidden cards
		const hiddenCards = cards.filter((card)=> card.classList.contains('hidden'))
		// add divider
		const dividerDiv = document.createElement('div')
		dividerDiv.classList.add('grid-divider');
		hiddenCards[0].insertAdjacentElement('beforebegin', dividerDiv);
		// show next batch of cards
		hiddenCards.slice(0, LOAD_AMOUNT).map((card)=> card.classList.remove('hidden'))
		// hide show more button
		if (hiddenCards.length <= LOAD_AMOUNT) {
			showMoreWrapper.classList.add('hidden');
		}
	} else {
		console.error('fn SD_SHOW_MORE_CARDS: No .section-cards-three-col, .grid-three-col, #view-more-cards found')
	}

	console.log('loading more')
}